import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Checkbox } from 'antd';
import classnames from 'classnames';
import TabeeAuth from '../../../tabee-auth';
import { strings, ui } from '../../../tools';
const PasswordForm = ({
  withRemember,
  errorMessage,
  translator,
  i18nPrefix,
  inputClassName,
  onResult
}) => {
  const t = translator,
    prefix = i18nPrefix ? `${i18nPrefix}.` : '',
    rememberKey = 'tabee-go-remember',
    dismissHost = ['localhost:3001', 'auth.tabee.mobi', 'auth-dev.tabee.mobi', 'auth-stage.tabee.mobi'],
    isAvoidedHost = host => dismissHost.indexOf(host.toLowerCase() > -1),
    [mode, $mode] = useState('email'),
    [email, $email] = useState(''),
    [code, $code] = useState(''),
    [remember, $remember] = useState(localStorage.getItem(rememberKey) === 'true'),
    [locked, $locked] = useState(false),
    [message, $message] = useState(''),
    codeMode = event => {
      $locked(false);
      if (!event.status || event.status >= 300) {
        const msg = event.message === '<' ? 'something went wrong' : event.message === 'Not found' ? 'email not found' : event.message;
        $message(msg);
        if (strings.toKey(msg.split(',')[0]) === 'alreadySent') {
          $mode('code');
        }
      } else {
        $mode('code');
      }
      ui.focusFirstInput();
    },
    requestCode = () => {
      if (locked || !email) return;
      $locked(true);
      $message('');
      const query = new URLSearchParams(window.location.search),
        redirect = query.get('redirect_uri'),
        returnURL = query.get('return_url');
      TabeeAuth.signIn2fa({
        email,
        source: {
          redirect_uri: redirect || (isAvoidedHost(window.location.host) ? '' : `${window.location.host}/auth/sso`),
          return_url: returnURL || (window.location.pathname !== '/login' ? window.location.pathname : '')
        }
      }).then(codeMode).catch(codeMode);
    },
    handleLogin = () => {
      if (locked || !email || !code) return;
      $locked(true);
      $message('');
      TabeeAuth.signInCode({
        email,
        code
      }).then(onResult).catch(event => {
        $locked(false);
        $code('');
        $message(!event.message || event.message === 'Error' || event.message === 'Not found' ? 'Wrong code' : event.message);
        ui.focusFirstInput();
      });
    },
    checkDisabledSubmit = () => {
      if (locked) return true;
      switch (mode) {
        case 'code':
          return !code;
        case 'email':
        default:
          return !email;
      }
    },
    getSubmitHandler = () => {
      switch (mode) {
        case 'code':
          return handleLogin;
        case 'email':
        default:
          return requestCode;
      }
    },
    getSubmitText = () => {
      switch (mode) {
        case 'code':
          return locked ? t(`${prefix}loginSigningIn`) : t(`${prefix}loginSignIn`);
        case 'email':
        default:
          return locked ? t(`${prefix}gettingCode`) : t(`${prefix}getCode`);
      }
    },
    getView = () => {
      switch (mode) {
        case 'code':
          return /*#__PURE__*/React.createElement(Input, {
            autoFocus: true,
            className: classnames('tabee-login__input', 'tabee_login__input-code', inputClassName),
            placeholder: t(`${prefix}code`),
            disabled: locked,
            value: code,
            autofill: "one-time-code",
            autoComplete: "one-time-code",
            type: "number",
            onChange: e => $code((e.target.value || '').trim().toLowerCase()),
            onPressEnter: handleLogin
          });
        case 'email':
        default:
          return /*#__PURE__*/React.createElement(Input, {
            autoFocus: true,
            className: classnames('tabee-login__input', 'tabee_login__input-email', inputClassName),
            placeholder: t(`${prefix}email`),
            disabled: locked,
            value: email,
            autofill: "email",
            autoComplete: "email",
            type: "email",
            onChange: e => $email((e.target.value || '').trim().toLowerCase()),
            onPressEnter: requestCode
          });
      }
    };
  useEffect(() => {
    localStorage.setItem(rememberKey, remember.toString());
  }, [remember]);
  useEffect(() => {
    $message(errorMessage);
    $locked(false);
  }, [errorMessage]);
  useEffect(() => {
    ui.focusFirstInput();
  }, []);
  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Item, null, getView()), /*#__PURE__*/React.createElement(Form.Item, {
    className: "tabee-login__offset-wrap"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "tabee-login__submit",
    type: "primary",
    disabled: checkDisabledSubmit(),
    onClick: getSubmitHandler()
  }, getSubmitText())), withRemember && /*#__PURE__*/React.createElement(Form.Item, {
    className: "tabee-login__offset-wrap"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    className: classnames("tabee-login__checkbox", 'tabee-login__remember', inputClassName),
    checked: remember,
    disabled: locked,
    onChange: () => $remember(!remember)
  }, t(`${prefix}keepSignIn`))), !!message && /*#__PURE__*/React.createElement("div", {
    className: "tabee-login__message"
  }, t(`errors.${strings.toKey((typeof message === 'string' ? message : 'networkError').split(',')[0])}`)));
};
export default PasswordForm;